import type { EngagementScene } from '../../types';
import { isConnectActive } from '../shared/connect';

/**
 * §8.11 Flow K Connect check, evaluated when the expert opens the drawer:
 * does the expert lack an active Stripe Connect account? Delegates to the
 * shared `isConnectActive` derivation so the "active" rule has one home.
 *
 * Scenes omitting `expert_connect` are treated as Connect active, so
 * pre-existing Make Offer fixtures render ungated.
 */
export function isConnectBlocked(scene: EngagementScene): boolean {
  return !isConnectActive(scene);
}

/**
 * §8.11 blocking banner — renders above the rate field when the Connect
 * check fails; the composition root also disables Make Offer.
 *
 * **Deliberately not spec-verbatim.** The spec's copy promises "We've emailed
 * you the setup link", and no such email exists: there is no payout or Connect
 * route in the api's engagement `eventRoutes`, and no template for one under
 * `api/emails/`. Building it is ENG-5297, still in Definition. Until it ships,
 * that sentence sends the expert to an inbox that will never receive anything
 * and away from the setup button beside this banner (ENG-5708). Restore it with
 * the email, not before.
 */
export default function ConnectGateBanner(): JSX.Element {
  return (
    <div
      role="alert"
      className="flex flex-col gap-4 rounded-md border border-yellow-700/40 bg-yellow-50 px-16 py-12 dark:bg-yellow-900/20"
    >
      {/* A JS string, not JSX text, so the copy stays character-exact against
          the constant the prototype's tests compare it to. */}
      <span className="text-yellow-900 body-2 dark:text-yellow-200">
        {`You need to complete Stripe Connect setup before you can make an offer on a paid engagement. Setting it up takes about 5 minutes. Return here once your Connect account is active.`}
      </span>
    </div>
  );
}
